import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@/components/ui/accordion';

export interface TypeAccordionStaticProps {
    id: number;
    question: string;
    answer: string;
}

export default function AccordionStatic(props: TypeAccordionStaticProps) {
    const { question, answer } = props;

    return (
        <Accordion dir="rtl" type="single" collapsible>
            <AccordionItem value="item-1">
                <AccordionTrigger className="bg-primary-shaded px-5 rounded-xl hover:no-underline py-2">
                    <h3 className="text-sm text-right">{question}</h3>
                </AccordionTrigger>
                <AccordionContent className="bg-white px-2 pb-4 pt-2 rounded-xl text-start">
                    <h4 className="font-normal text-sm px-2">{answer}</h4>
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    );
}
